import { API_TIMEOUT } from "Const"
import axios from "./axios"
/**
 * 見積保存APIのリクエスト
 * @param {any} data - リクエスト用JSON
 * @return {object} - 見積保存APIのレスポンス結果
 */
export default function saveEstimation(data: any) {
  return axios
    .post("/save", data, API_TIMEOUT)
    .then((res: any) => {
      return res
    })
    .catch((err: any) => {
      return err
    })
}
